module.exports = __webpack_public_path__ + "static/media/iconnotebook.6273da1d.svg";